module.exports = "/static/assets/a4218323544d10ac955ba13f86ea232e.png";